import React from 'react';
import {DatePicker} from "antd";

function FormRangePicker(
    {
        allowEmpty,
        allowClear,
        value,
        bordered = false,
        defaultValue,
        maxLength,
        showCount,
        onChange,
        format,
        time = false,
        ...props
    }
) {

    return (
        <DatePicker
            allowEmpty={allowEmpty}
            bordered={bordered}
            showCount={showCount}
            defaultValue={defaultValue}
            maxLength={maxLength}
            onChange={onChange}
            allowClear={allowClear}
            value={value}
            format={format}
            showTime={time}
            {...props}
        />
    );
}

export default FormRangePicker;
